import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { DeliveryAddressData } from '../customer-address-control/customer-address-control.component';
import { DeliveryAddress } from '../../shared-html-components/customer-search/customer-search.component';

@Component({
  selector: 'app-delivery-address-select',
  templateUrl: './delivery-address-select.component.html',
  styleUrls: ['./delivery-address-select.component.css']
})
export class DeliveryAddressSelectComponent implements OnInit, OnChanges {

  @Input('data') data: Array<DeliveryAddressData>;
  @Input('id') id: string;
  @Output('select') select = new EventEmitter<DeliveryAddressData>();

  show: Array<DeliveryAddressData>;
  input = '';

  index: number = null;
  selected: DeliveryAddressData = null;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(change: SimpleChanges) {
    if (!!change.id && change.id.currentValue != change.id.previousValue) {
      this.selected = this.data.find(x => x.deliveryId == this.id);
      this.input = '';
    }
    if (!!change.data && change.data.currentValue != null && change.data.currentValue != undefined) {
      this.show = this.data.slice(0, 60);
    }
  }

  filter(event: KeyboardEvent) {
    if (this.input != '' && ![13, 38, 40].includes(event.keyCode)) {
      let i = this.input.toLowerCase();
      this.show = this.data.filter(x =>
        !!x.name && x.name.toLowerCase().match(i) ||
        !!x.street && x.street.toLowerCase().match(i) ||
        !!x.zipCode && x.zipCode.toLowerCase().match(i) ||
        !!x.city && x.city.toLowerCase().match(i) ||
        !!x.email && x.email.toLowerCase().match(i) ||
        !!x.phone && x.phone.toLowerCase().match(i)
      )
      if (this.show.length == 0) {
        this.input = this.input.slice(0, -1);
        this.filter(event)
      }
    }
    else if (![13, 38, 40].includes(event.keyCode)) {
      if (this.input == '') {
        //this.show = [];
      }
      else {
        this.show = this.data.slice(0, 60);
      }
    }
    else {
      switch (event.keyCode) {
        case (13): {
          // Enter
          if (this.index != null) {
            this.change(this.index);
          }
          ; break
        }
        case (38): {
          // Up arrow
          if (this.index == null || this.index == 0) {
            this.index = this.show.length - 1;
          }
          else {
            this.index = this.index - 1;
          }
          var elmnt = document.getElementById(this.show[this.index].deliveryId);
          elmnt.scrollIntoView();
          ; break
        }
        case (40): {
          // Down arrow
          if (this.index == null || this.index == this.show.length - 1) {
            this.index = 0;
            var elmnt = document.getElementById(this.show[this.index].deliveryId);
            elmnt.scrollIntoView();
            ; break
          }
          else {
            this.index = this.index + 1;
            var elmnt = document.getElementById(this.show[this.index].deliveryId);
            elmnt.scrollIntoView();
            ; break
          }
          
        }
      }
    }
  }

  clear() {
    this.input = '';
    this.selected = null;
  }

  async change(i) {
    let address = await this.show[i];
    //console.log(address)
    this.select.emit(address);
    this.input = '';
  }

  clickTest(e, i) {
    console.log(e,i)
  }

}
